module.exports = __webpack_public_path__ + "static/img/Infor_transmission.9db62721.png";